import * as UI from 'ui';
import * as Select from 'app/area/case/selectors';
import * as appComponents from 'app/components';
import { Dummy } from 'app/infrastructure/ui/debug-render';
import * as AppEnhance from 'app/components/enhancers';
import * as UIEnhance from 'ui/common/enhancers';
import * as caseComponents from 'app/area/case/components';
import * as AddFeature from 'app/area/case/features';
import * as caseData from 'app/area/case/case-data-model';
import { SharePreset } from 'app/area/case/features';
import { ControlType } from 'app/infrastructure/ui';
import { ComponentIndex } from 'app/infrastructure/ui/types-uischema';
import { withCopyRiskEvaluation, withGetUiDefinition } from 'app/area/case/features/loss-potential-evaluation';

const Enhance = {...AppEnhance, ...UIEnhance};

export const reportModeComponents: ComponentIndex =  {

  [ControlType.NotImplemented]: {
    component: Dummy,
    configType: ControlType.NotImplemented
  },

  [ControlType.SectionPanel]: {
    component: Dummy,
    configType: ControlType.SectionPanel
  },

  [ControlType.View]: {
    component: UI.Paper,
    enhancers: [Enhance.withClassNames('compact')],
    configType: ControlType.View
  },

  [ControlType.LinkHeading]: {
    component: UI.LinkHeading,
    enhancers: [Enhance.withClassNames('compact')],
    selectors: [Select.urlToConnectedCase(), Select.urlToCase()],
    configType: ControlType.LinkHeading
  },

  [ControlType.HeaderPanel]: {
    component: appComponents.ReadHeaderPanel,
    enhancers: [Enhance.withClassNames('compact'), AddFeature.withSharing(SharePreset.case), withCopyRiskEvaluation(), 
      withGetUiDefinition, AddFeature.withCallsToActions, Enhance.withProperty('reloadOnCallsToActions', false)],
    selectors: [Select.headerVisibilityConfiguration, Select.casePermissions, Select.urlToCase(), Select.caseId,
      Select.templateURL, Select.sharedState, Select.lossPotentialEvaluationValues,
      Select.entityId, Select.connectedCasesMaxSequence, Select.connectedDrafts],
    configType: ControlType.HeaderPanel
  },

  [ControlType.FlexPanel]: {
    component: UI.FlexPanel,
    configType: ControlType.FlexPanel
  },

  [ControlType.Tile]: {
    component: Enhance.withLink(UI.Tile),
    configType: ControlType.Tile,
    selectors: [
      Select.urlToChildEntity,
      Select.primaryKeyFromContext(),
      Select.editDocumentItemVisibility
    ],
    enhancers: [Enhance.withProperty('showDetailsButton', false)]
  },

  [ControlType.FactBox]: {
    component: caseComponents.FactBox,
    selectors: [
      Select.riskValues,
      Select.childEntityValuesAsProperty('childValueItems', [
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.consequences }],
          propName: (caseData.columnName[caseData.tableName.consequences] as any).actConsConsequenceIcons
        }]),
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.action }],
          propName: (caseData.columnName[caseData.tableName.action] as any).numberOfActions
        },
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.action }],
          propName: (caseData.columnName[caseData.tableName.action] as any).numberOfClosedActions,
          dataTag: (caseData.columnName[caseData.tableName.action] as any).actionCompletedDate
        },
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.object }],
          propName: (caseData.columnName[caseData.tableName.object] as any).numberOfFiles
        },
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.comment }],
          propName: (caseData.columnName[caseData.tableName.comment] as any).numberOfComments
        },
        {
          entityPath: [
            { entityType: caseData.tableName.trans },
            { entityType: caseData.tableName.connectionTypes, id: 1},
            { entityType: caseData.tableName.connectedCases}
          ],
          propName: (caseData.propNameConnectionType[caseData.connectionType.superior] as any).numberOfSuperiorCases
          },
        {
          entityPath: [
            { entityType: caseData.tableName.trans },
            { entityType: caseData.tableName.connectionTypes, id: 2},
            { entityType: caseData.tableName.connectedCases}
          ],
          propName: (caseData.propNameConnectionType[caseData.connectionType.subordinate] as any).numberOfSubordinateCases
        },
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.causes }],
          propName: (caseData.columnName[caseData.tableName.causes] as any).numberOfCauses
        },
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.involvedPerson }],
          propName: (caseData.columnName[caseData.tableName.involvedPerson] as any).numberOfInvolvedPersons
        },
        {
          entityPath: [{ entityType: caseData.tableName.trans },
                       { entityType: caseData.tableName.attachmentType, id: 2},
                       { entityType: caseData.tableName.link }],
                       propName: (caseData.columnName[caseData.tableName.link] as any).numberOfLinks
        },
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.involvedDrug }],
          propName: (caseData.columnName[caseData.tableName.involvedDrug] as any).numberOfInvolvedDrugs
        },
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.assessment }],
          propName: (caseData.columnName[caseData.tableName.assessment] as any).numberOfAssessments
        }
      ]),
      Select.integrityValues,
      Select.checklistValues,
      Select.sectionLinks,
      Select.urlToCase(),
      Select.reportCategory,
      Select.connectedCasesIds,
      Select.bowtieSupported,
      Select.caseId
    ],
    enhancers: [Enhance.withClassNames('compact'), AddFeature.withFileDownload(caseData.tableName.object)],
    configType: ControlType.FactBox
  },

  [ControlType.SurveyLink]: {
    component: UI.Link,
    selectors: [Select.templateURL],
    enhancers: [],
    configType: ControlType.SurveyLink
  },

  [ControlType.Link]: {
    component: UI.Link,
    selectors: [Select.domainTemplateUrl],
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3})],
    configType: ControlType.Link
  },

  [ControlType.Signature]: {
    component: UI.DisplayDate,
    selectors: [],
    enhancers: [],
    configType: ControlType.Signature
  },

  [ControlType.CompactTile]: {
    component: Enhance.withLink(UI.CompactTile),
    configType: ControlType.CompactTile,
    selectors: [
      Select.urlToChildEntity(true),
      Select.editDocumentItemVisibility
    ],
    enhancers: [Enhance.withProperty('showDetailsButton', false)]
  },

  [ControlType.CompactTileHeader]: {
    component: appComponents.CompactTileHeader,
    selectors: [Select.tileHeaderPrimaryKeyWithReportKeyLabel],
    configType: ControlType.CompactTileHeader
  },

  [ControlType.DisplayCodesStatus]: {
    component: UI.DisplayCodes,
    enhancers: [Enhance.withProperty('displayBackgroundColor', 'false'),
                Enhance.withProperty('style', 'secondary')],
    configType: ControlType.DisplayCodesStatus
  },

  [ControlType.BadgeListFileUploader]: {
    component: caseComponents.BadgeListFileUploader,
    selectors: [Select.print],
    enhancers: [AddFeature.withFileDownload(), Enhance.withProperty('clickable', false)],
    configType: ControlType.BadgeListFileUploader
  },

  [ControlType.LossPotentialEvaluation]: {
    component: caseComponents.LossPotentialEvaluation,
    selectors: [Select.primaryKeyFromContext(), Select.urlToChildEntity],
    enhancers: [Enhance.withProperty('activeChild', false)],
    configType: ControlType.LossPotentialEvaluation
  },

  [ControlType.LossPotentialEvaluationTileView]: {
    component: caseComponents.LossPotentialEvaluationTileView,
    selectors: [Select.childEntities, Select.hideLossPotentialEvaluation],
    enhancers: [Enhance.withClassNames('compact'), Enhance.withProperty('navigateToUrl', true)],
    configType: ControlType.LossPotentialEvaluationTileView
  }
};
